import Lottie from "lottie-react";
import { useDonationList } from "../../reuseableEffects";
import emptyState from "../../../assets/animations/emptyTransaction.json";

// Function to format the date as "4th November 2023"
const formatDate = (dateStr) => {
  const dateObj = new Date(dateStr);

  const getDaySuffix = (day) => {
    if (day > 3 && day < 21) return 'th'; // For 11th - 20th
    switch (day % 10) {
      case 1: return 'st';
      case 2: return 'nd';
      case 3: return 'rd';
      default: return 'th';
    }
  };

  const day = dateObj.getDate();
  const daySuffix = getDaySuffix(day);

  const monthNames = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const month = monthNames[dateObj.getMonth()];
  const year = dateObj.getFullYear();

  return `${day}${daySuffix} ${month}, ${year}`;
};

const Donations = ({ campaignReference }) => {
  const donorList = useDonationList(campaignReference);

  return (
    <div>
      {donorList.length === 0 ? (
        <div className="">
          <div className="flex justify-center">
            <Lottie animationData={emptyState} loop={true} className="w-36" />
          </div>
          <p className="text-center text-sm text-secondary px-4 pb-8">
            This campaign hasn't received any donations yet. Be the first to support this campaign! Your contribution can make a real difference.
          </p>
        </div>
      ) : (
        <div className="max-h-[400px] overflow-auto px-4 pb-4">
          {donorList.map((donor, index) => (
            <div key={index} className="py-3 last:pb-0 border-b last:border-0">
              <div className="flex divide-x">
                <div className="text-sm text-brandGreen pe-2">&#8358;{donor.amount}</div>
                <div className="text-sm text-secondary ps-2">{formatDate(donor.date)}</div>
              </div>
              <p className="truncate capitalize text-sm">{donor.ananymous === "" ? donor.names : "Anonymous donor 🙏🏽"}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Donations;
